import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import ShareFormContainer from "./shareFormContainer";

const ShareButton = styled(Button)`
  && {
    text-transform: none;
    width: 132px;
    color: #fff;
    background: #005aa9;
    font-family: work sans;
    margin-right: 20px;
    margin-left: 10px;
  }
`;

const CancelButton = styled(Button)`
  && {
    text-transform: none;
    width: 132px;
    color: #005aa9;
    background: #fff;
    border-color: #005aa9;
    font-family: work sans;
  }
`;

const ShareReportForm = props => {
  const { values, errors, handleSubmit, handleChange, setOpenShareModal, taskDetails, setFieldValue, emailsList, setDisplayShareReportScreen } = props;

  useEffect(() => {
    setFieldValue("email", emailsList);
    const dealName = taskDetails?.deal?.name;
    const splitReportName = taskDetails.reportGroup?.reportName.split(" - ");
    const reportFrequency = splitReportName[2].trim();
    const subject = `${dealName} - ${reportFrequency}`;
    setFieldValue("subject", subject);
  }, [emailsList]);

  const handleClose = () => {
    setOpenShareModal(false);
    setDisplayShareReportScreen(false);
  };

  const handleOnChange = (name, value) => {
    setFieldValue(name, value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <ShareFormContainer
        values={values}
        errors={errors}
        handleOnChange={handleOnChange}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        taskDetails={taskDetails}
      />
      <DialogActions style={{ marginBottom: "20px" }}>
        <CancelButton onClick={handleClose} variant="outlined">
          Cancel
        </CancelButton>
        <ShareButton variant="contained" type="submit">
          Share
        </ShareButton>
      </DialogActions>
    </form>
  );
};

export default ShareReportForm;
